import React from 'react'
import { PageHead } from '@fs/zion-head'
import { useTranslation } from 'react-i18next'
import { usePageView } from '@fs/zion-analytics'
import { i18n } from '@fs/zion-locale'
import { useEffectiveUser } from '@fs/zion-user'
import { useAamState, useAamDispatch, useAamInitialization, ACTIONS } from '../state/AamStore'
import useDSApplicationMode from '../../../shared/hooks/useDSApplicationMode'
import Accessibility from '../../../shared/components/Accessibility'
import PageLoadingIndicator from '../../../shared/components/PageLoadingIndicator'
import AAMContent from './AAMContent'
import LanguageWarningDialog from './LanguageWarningDialog/LanguageWarningDialog'
import getCanonicalUrl from '../../../shared/helpers/canonicalUrl'

export default function AAMMain() {
  const { t } = useTranslation()
  const initData = { page_detail: 'All About Me - Main' }
  usePageView(initData)
  const user = useEffectiveUser() // Using effective user vs user to support helper mode
  const appState = useAamState()
  const aamDispatch = useAamDispatch()
  const appMode = useDSApplicationMode()
  const toggleAccessibity = (access) => {
    aamDispatch({ type: ACTIONS.STATE_UPDATE, key: 'isAccessible', data: !access })
  }

  useAamInitialization(user)

  return appState.isLoading ? (
    <PageLoadingIndicator />
  ) : (
    <>
      <PageHead
        omitSiteName
        title={t('landing-page.aam.page.title', 'All About Me: Your birth year was a vibe—relive it!')}
        url={getCanonicalUrl()}
      />
      {appMode === 'STATION' && <Accessibility onClick={toggleAccessibity} pullDown />}
      <AAMContent tileData={appState.tileData} year={appState.year} user={user} />
      {user.signedIn && (
        <LanguageWarningDialog
          language={i18n.language}
          region={appState.tileData?.[0]?.region}
          year={appState.tileData?.[0]?.year}
        />
      )}
    </>
  )
}
